/* TRIO – FAQ et contact */
(function () {
  'use strict';
  if (window.__trioFaq) return;
  window.__trioFaq = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, "'"); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(s) {
    var qs = [].slice.call(s.querySelectorAll('[data-tf-q]'));
    var groups = [].slice.call(s.querySelectorAll('[data-tf-group]'));
    var links = [].slice.call(s.querySelectorAll('[data-tf-link]'));
    var input = s.querySelector('[data-tf-input]'), clear = s.querySelector('[data-tf-clear]'), box = s.querySelector('.tf-search');
    var res = s.querySelector('[data-tf-res]'), empty = s.querySelector('[data-tf-empty]'), term = s.querySelector('[data-tf-term]');
    var toastEl = s.querySelector('[data-tf-toast]'), toastT;
    if (!input) return;

    function setTop() {
      var hg = document.getElementById('header-group'), ann = document.querySelector('.tw-ann');
      if (!hg) return;
      var h = hg.offsetHeight - (ann ? ann.offsetHeight : 0);
      if (h > 20 && h < 200) s.style.setProperty('--tf-top', h + 'px');
    }
    setTop(); window.addEventListener('resize', setTop);

    if (!reduce) { s.classList.add('is-armed'); requestAnimationFrame(function () { requestAnimationFrame(function () { s.classList.add('is-ready'); }); }); }

    function toast(msg) {
      if (!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('is-on');
      clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
    }

    qs.forEach(function (q) {
      var b = q.querySelector('button'), t = q.querySelector('[data-tf-t]');
      q._b = b; q._t = t; q._label = t.textContent;
      q._hay = norm(t.textContent + ' ' + q.querySelector('.tf-q__in').textContent);
      b.addEventListener('click', function () { toggle(q, !q.classList.contains('is-open')); });
    });
    function toggle(q, on) {
      q.classList.toggle('is-open', on);
      q._b.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function counts() {
      groups.forEach(function (g) {
        if (!g.id) return;
        var n = g.querySelectorAll('[data-tf-q]:not([hidden])').length;
        var c = s.querySelector('[data-tf-count="' + g.id + '"]'); if (c) c.textContent = n;
        var l = s.querySelector('[data-tf-link="' + g.id + '"]'); if (l) l.classList.toggle('is-empty', n === 0);
      });
    }
    counts();

    var timer;
    function search() {
      var raw = input.value.trim(), q = norm(raw), words = q.split(/\s+/).filter(function (w) { return w.length > 1; });
      box.classList.toggle('has-q', raw.length > 0); clear.hidden = raw.length === 0;
      var shown = 0, hits = [];
      qs.forEach(function (it) {
        var ok = !words.length || words.every(function (w) { return it._hay.indexOf(w) > -1; });
        it.hidden = !ok;
        if (ok && words.length) {
          var label = it._label, n = norm(label), marks = [];
          words.forEach(function (w) { var i = n.indexOf(w); while (i > -1) { marks.push([i, i + w.length]); i = n.indexOf(w, i + w.length); } });
          marks.sort(function (a, b) { return a[0] - b[0]; });
          var out = '', last = 0;
          marks.forEach(function (m) { if (m[0] < last) return; out += esc(label.slice(last, m[0])) + '<mark>' + esc(label.slice(m[0], m[1])) + '</mark>'; last = m[1]; });
          it._t.innerHTML = out + esc(label.slice(last));
        } else { it._t.textContent = it._label; }
        if (ok) { shown++; hits.push(it); }
      });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-tf-q]:not([hidden])'); });
      empty.hidden = shown > 0; term.textContent = raw;
      if (!words.length) { res.textContent = ''; qs.forEach(function (it) { toggle(it, it._kept === true); }); }
      else {
        res.textContent = shown ? shown + (shown > 1 ? ' réponses trouvées' : ' réponse trouvée') : '';
        qs.forEach(function (it) { toggle(it, !it.hidden && hits.length <= 2); });
      }
      counts();
    }
    input.addEventListener('focus', function () { if (!input.value) qs.forEach(function (it) { it._kept = it.classList.contains('is-open'); }); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 90); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; search(); }
      if (e.key === 'Enter') { e.preventDefault(); var f = qs.filter(function (it) { return !it.hidden; })[0]; if (f) { toggle(f, true); f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } }
    });
    clear.addEventListener('click', function () { input.value = ''; search(); input.focus(); });
    s.querySelectorAll('[data-tf-reset]').forEach(function (b) { b.addEventListener('click', function () { input.value = ''; search(); input.focus(); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey) return;
      var a = document.activeElement; if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable)) return;
      e.preventDefault(); input.focus(); input.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });

    function go(id) { var t = document.getElementById(id); if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    links.forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); go(a.dataset.tfLink); }); });
    s.querySelectorAll('[data-tf-jump]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); go(a.dataset.tfJump); var f = s.querySelector('#tf-email,#tf-name'); if (f && !('ontouchstart' in window)) setTimeout(function () { f.focus({ preventScroll: true }); }, 700); }); });
    var nav = s.querySelector('.tf-nav__in');
    function setActive(id) {
      links.forEach(function (a) {
        var on = a.dataset.tfLink === id; a.classList.toggle('is-on', on);
        if (on && nav && nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: a.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' });
      });
    }
    if ('IntersectionObserver' in window && links.length) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); }); }, { rootMargin: '-35% 0px -60% 0px' });
      groups.forEach(function (g) { if (g.id) io.observe(g); });
    }
    if (links[0]) links[0].classList.add('is-on');

    function toHash(hash, smooth) {
      if (!hash || hash.length < 2) return false;
      var t; try { t = s.querySelector(hash); } catch (e) { return false; }
      if (!t) return false;
      if (t.matches('[data-tf-q]')) toggle(t, true);
      t.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'auto', block: 'start' });
      return true;
    }
    if (location.hash) setTimeout(function () { toHash(location.hash, false); }, 250);
    window.addEventListener('hashchange', function () { toHash(location.hash, true); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]'); if (!a || a.closest('[data-tfq]') && a.hasAttribute('data-tf-jump')) return;
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.pathname === location.pathname && u.hash && toHash(u.hash, true)) { e.preventDefault(); if (history.replaceState) history.replaceState(null, '', u.hash); }
    });

    var st = s.querySelector('[data-tf-status]');
    if (st) {
      var open = +st.dataset.open || 9, close = +st.dataset.close || 20;
      var days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
      var upd = function () {
        var p = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        var d = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday), h = parseInt(p.hour, 10) % 24;
        var isOpen = d >= 1 && d <= 6 && h >= open && h < close;
        st.classList.toggle('is-open', isOpen);
        st.querySelector('[data-tf-state]').textContent = isOpen ? "L'équipe est en ligne" : "L'équipe est hors ligne";
        var next;
        if (isOpen) next = "jusqu'à " + close + 'h';
        else {
          var nd = d, later = h < open && d >= 1 && d <= 6;
          if (!later) { do { nd = (nd + 1) % 7; } while (nd === 0); }
          next = 'On vous répond dès ' + (later ? "aujourd'hui" : (nd === (d + 1) % 7 ? 'demain' : days[nd])) + ' ' + open + 'h';
        }
        st.querySelector('[data-tf-next]').textContent = next;
      };
      upd(); setInterval(upd, 60000);
    }

    s.querySelectorAll('[data-tf-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.tfCopy, sp = b.querySelector('span'), orig = sp.textContent, done = function () { b.classList.add('is-done'); sp.textContent = 'Adresse copiée'; toast('Adresse e-mail copiée'); setTimeout(function () { b.classList.remove('is-done'); sp.textContent = orig; }, 2200); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(done, function () { location.href = 'mailto:' + v; });
        else location.href = 'mailto:' + v;
      });
    });

    var form = s.querySelector('#tf-form');
    if (form) {
      var msg = form.querySelector('[data-tf-msg]');
      if (msg) {
        var grow = function () { msg.style.height = 'auto'; msg.style.height = Math.min(msg.scrollHeight + 2, 420) + 'px'; };
        msg.addEventListener('input', grow);
      }
      form.addEventListener('submit', function (e) {
        var bad = null;
        form.querySelectorAll('[required]').forEach(function (f) {
          var ok = f.value.trim() && (f.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.value.trim()));
          f.closest('.tf-f').classList.toggle('is-bad', !ok);
          if (!ok && !bad) bad = f;
        });
        if (bad) { e.preventDefault(); bad.focus(); toast(bad.type === 'email' ? 'Vérifiez votre adresse e-mail' : 'Ajoutez votre message'); return; }
        var btn = form.querySelector('.tf-send'); if (btn) { btn.classList.add('is-busy'); btn.querySelector('span').textContent = 'Envoi…'; }
      });
      form.querySelectorAll('input,textarea').forEach(function (f) { f.addEventListener('input', function () { var w = f.closest('.tf-f'); if (w) w.classList.remove('is-bad'); }); });
      var ok = form.querySelector('[data-tf-ok]');
      if (ok || form.querySelector('.tf-err')) { setTimeout(function () { go('contact'); if (ok) ok.focus({ preventScroll: true }); }, 250); }
    }
  }

  function boot() { document.querySelectorAll('[data-tfq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
